import PostApi from '@/postApi';
export default {
	namespaced: true,
	state: {
		rechargeData: null
	},
	actions: {
		async recharge({
			commit
		},param) {
			let getRecharge = await PostApi.recharge(param);
			getRecharge = getRecharge?getRecharge.data : null;
			return commit('setRecharge', getRecharge);
		},
		async wxRecharge({
			commit
		},param) {
			console.log('wxRecharge',commit);
			let getRecharge = await PostApi.wxRecharge(param);
			return getRecharge;
		},
		async zfbRecharge({
			commit
		},param) {
			console.log('zfbRecharge',commit);
			let getRecharge = await PostApi.zfbRecharge(param);
			return getRecharge;
		},
		async postWxLogin({commit},param) {
			const getWxLoginData = await PostApi.postWxLogin(param);
			console.log('getWxLoginData',commit,getWxLoginData);
			return getWxLoginData;
		},
		async postRedirect({commit},param) {
			const getRedirectData = await PostApi.postRedirect(param);
			console.log('getRedirectData',commit,getRedirectData);
			return getRedirectData;
		},
		async getPayInfo({commit},param) {
			const getPayInfoData = await PostApi.getPayInfo(param);
			console.log('getPayInfoData',commit,getPayInfoData);
			return getPayInfoData;
		},
		async bankRecharge({commit},param) {
			const getBankRechargeData = await PostApi.bankRecharge(param);
			console.log('getBankRechargeData',commit,getBankRechargeData);
			return getBankRechargeData;
		},
	},
	mutations: {
		setRecharge(state, payload) {
			state.rechargeData = payload;
		},
	},
}
